import React from 'react';
import { useSelector } from "react-redux";
import { Stack } from "@mui/material";
import UserProfile from '../../features/userProfile/UserProfile';
import OrganizationInfo from '../../features/organizationInfo/OrganizationInfo';

export default function UserDetails() {
  const user = useSelector(state => state.user.user);
  return (
    <Stack sx={{ maxWidth: 1200 }}>
      <UserProfile user={user} />
      <OrganizationInfo />
    </Stack>
  )
}
